import { fetchDashboardView } from './actions/fetchView';
import { getUnreadConversationCount } from './actions/getUnreadConversationCount';

const DashboardService = {
  getDashboardView: fetchDashboardView,
  getUnreadConversationCount,
};

export default DashboardService;
export type { DashboardViewOpts } from './actions/fetchView';
